import { z } from 'zod'
import { zodDate } from '../utilities/zodDate'

export const attendeeProperties = {
  uuid: z.string(),
  scheduledCourseEventDateUuid: z.string(),
  booking: z.object({
    uuid: z.string(),
    userUuid: z.string(),
    scheduledCourseEventUuid: z.string().nullish(),
  }),
  attended: z.boolean().nullable(),
  updatedAt: zodDate(),
  createdAt: zodDate(),
}

export const attendeeParser = z.object(attendeeProperties)

export type Attendee = z.infer<typeof attendeeParser>
